import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { AssetTypeEntity } from '../../../../entities/assets/asset';
import { EntitySubStatus } from '../../../../entities/entity.status/entity.status';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { getSchema } from '../../decorators/utilities/get.merge.schema';

@MergeSchema({
    entity: ActivityEntityName.Asset,
    name: 'AssetMergeSchema',
})
export class AssetMergeData {
    @MergeField()
    assetNumber: string;

    @MergeField()
    name: string;

    @MergeField()
    assetType: string;

    @MergeField()
    lastServicedJob: string;

    @MergeField()
    lastServiceOn: string;

    @MergeField()
    status?: string;

    @MergeField()
    createdAt: string;

    @MergeField()
    childrenCount: number;
}

export const AssetMergeSchema = getSchema(AssetMergeData);